import { fromJS } from 'immutable';

import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  TOGGLE_EMAIL_ATTENDEES_OVERLAY,
  TOGGLE_ADD_ATTENDEES_OVERLAY,
  CANCEL_FAILED,
  CHECK_IN_ATTENDEE_FAILED,
  TOGGLE_INVITE_ATTENDEES_OVERLAY,
  REMOVE_INVITEE_FAILED,
  REMOVE_ATTENDEE_FAILED,
  TOGGLE_FORM_RESPONSES_OVERLAY,
  TOGGLE_FORM_AGGREGATIONS_OVERLAY,
  APPROVE_VOLUNTEER_TIME,
  DENY_VOLUNTEER_TIME,
  RESPOND_VOLUNTEER_TIME_SUCCESS,
  RESPOND_VOLUNTEER_TIME_FAILED,
  SET_OPT_IN_STATUS_FAILED,
  SET_OPT_IN_STATUS,
  SET_OPT_IN_STATUS_SUCCESS,
} from './constants';

export const initialState = fromJS({
  loading: false,
  emailAttendeesOverlayVisible: false,
  addAttendeesOverlayVisible: false,
  inviteAttendeesOverlayVisible: false,
  formAggregationsOverlayVisible: false,
  formResponsesOverlayUserId: null,
  error: false,
  volunteerTimeResponding: {},
  setOptInStatusLoading: false,
  setOptInStatusError: false,
});

function deedPageReducer(state = initialState, action) {
  switch (action.type) {
    case INIT:
      return state.set('loading', true);

    case INIT_SUCCESS:
      return state.set('loading', false);

    case INIT_FAILED:
      return state.merge({ loading: false, error: action.error });

    case TOGGLE_EMAIL_ATTENDEES_OVERLAY:
      return state.set('emailAttendeesOverlayVisible', action.visible);

    case TOGGLE_ADD_ATTENDEES_OVERLAY:
      return state.set('addAttendeesOverlayVisible', action.visible);

    case TOGGLE_INVITE_ATTENDEES_OVERLAY:
      return state.set('inviteAttendeesOverlayVisible', action.visible);

    case TOGGLE_FORM_RESPONSES_OVERLAY:
      return state.set('formResponsesOverlayUserId', action.userId);

    case TOGGLE_FORM_AGGREGATIONS_OVERLAY:
      return state.set('formAggregationsOverlayVisible', action.visible);

    case APPROVE_VOLUNTEER_TIME:
    case DENY_VOLUNTEER_TIME:
      return state.setIn(['volunteerTimeResponding', action.id], true);

    case RESPOND_VOLUNTEER_TIME_SUCCESS:
    case RESPOND_VOLUNTEER_TIME_FAILED:
      return state.setIn(['volunteerTimeResponding', action.id], false);

    case CANCEL_FAILED:
    case CHECK_IN_ATTENDEE_FAILED:
    case REMOVE_ATTENDEE_FAILED:
    case REMOVE_INVITEE_FAILED:
      return state.set('error', action.error);

    case SET_OPT_IN_STATUS:
      return state.set('setOptInStatusLoading', true);

    case SET_OPT_IN_STATUS_SUCCESS:
      return state.set('setOptInStatusLoading', false);

    case SET_OPT_IN_STATUS_FAILED:
      return state.set('setOptInStatusError', action.error).set('setOptInStatusLoading', false);

    default:
      return state;
  }
}

export default deedPageReducer;
